// extracted by mini-css-extract-plugin
export default {"hsRoot":"VerifyToken_hsRoot__OPK+M"};